import React, { useEffect, useState, useMemo, useContext } from 'react'
import * as classes from './Form.module.scss'
import cn from 'classnames'
import { TextField } from '../../../ui/TextField/TextField'
import axios from 'axios'
import { TextArea } from '../../../ui/TextArea/TextArea'
import { Button } from '../../../ui/Button/Button'
import { Link } from 'gatsby'
import Thanks from './Thanks/Thanks'
import { deleteHtmlTag } from '../../../../utils/deleteHtmlTag'
import { FormContext } from '../../../../context'
import { startAnimationScroll } from '../../../../utils/animations'
import splitTitleV2 from '../../../../utils/splitTitleV2'

function Form({ data, dataServer, lang }) {
    const { animationStart } = useContext(FormContext)

    const titleForm = useMemo(() => deleteHtmlTag(dataServer.titleForm.value, 'p'), [])

    const [isLoading, setIsLoading] = useState(false)
    const [successSubmit, setSuccessSubmit] = useState(false)
    const [formData, setFormData] = useState({ name: '', email: '', message: '' })
    const [formErrors, setFormErrors] = useState({ name: false, email: false })
    const [isFormSend, setIsFormSend] = useState(false)

    const [titlePrint, setTitlePrint] = useState(titleForm)

    let timer

    const onChangeFormData = (nameField, valueField) => {
        setFormData({ ...formData, [nameField]: valueField })
    }

    const sendMessage = () => {
        timer = setTimeout(() => setSuccessSubmit(false), 7000)
    }

    const handleSubmit = async (e) => {
        e.preventDefault()

        if (!isLoading) {
            let errors = false

            if (!formData.name) {
                setFormErrors((prev) => ({ ...prev, name: true }))
                errors = true
            }

            if (!formData.email) {
                setFormErrors((prev) => ({ ...prev, email: true }))
                errors = true
            }

            if (errors) {
                return false
            } else {
                setIsLoading(true)

                const dateTime = new Date()

                const dateDay = parseInt(dateTime.getDate())
                const dateMonth = parseInt(dateTime.getMonth()) + 1
                const dateYear = parseInt(dateTime.getFullYear())
                const dateFinal = `${dateYear}-${dateMonth < 10 ? '0' : ''}${dateMonth}-${dateDay < 10 ? '0' : ''}${dateDay}`

                const timeHour = parseInt(dateTime.getHours())
                const timeMin = parseInt(dateTime.getMinutes())
                const timeSec = parseInt(dateTime.getSeconds())
                const timeFinal = `${timeHour < 10 ? '0' : ''}${timeHour}:${timeMin < 10 ? '0' : ''}${timeMin}:${
                    timeSec < 10 ? '0' : ''
                }${timeSec}`

                const date = `${dateFinal}T${timeFinal}`

                const params = JSON.stringify({
                    data: {
                        type: 'item',
                        attributes: {
                            date: date,
                            name: formData.name,
                            email: formData.email,
                            message: formData.message,
                            site_language: lang === 'en' ? 'en' : 'hy'
                        },
                        relationships: {
                            item_type: {
                                data: {
                                    type: 'item_type',
                                    id: '1889915'
                                }
                            }
                        }
                    }
                })

                try {
                    const { data } = await axios.post('https://site-api.datocms.com/items', params, {
                        headers: {
                            Accept: 'application/json',
                            'Content-Type': 'application/json',
                            Authorization: 'Bearer 0714849ab4286b73d9b9c2ecc9841d'
                        }
                    })

                    if (data.data && data.data.id) {
                        setSuccessSubmit(true)
                        setIsFormSend(true)
                        sendMessage()

                        setFormData({
                            name: '',
                            email: '',
                            message: ''
                        })

                        setFormErrors({
                            name: false,
                            email: false
                        })
                    } else {
                        alert(lang === 'en' ? 'An error has occurred' : 'Սխալ է տեղի ունեցել')
                    }

                    setIsLoading(false)
                } catch (err) {
                    console.log(err)
                    setIsLoading(false)
                }
            }
        }
    }

    useEffect(() => {
        return () => clearTimeout(timer)
    }, [timer])

    const classAnimationTitle = 'anime-title-contacts-form'
    const classAnimationLine = 'anime-line-contacts-form'

    useEffect(() => {
        if (animationStart) {
            splitTitleV2(classAnimationTitle)
        }

        const observer = startAnimationScroll([
            { type: 'title', className: classAnimationTitle },
            { type: 'lineGorizont', className: classAnimationLine }
        ])

        return () => {
            if (observer) {
                observer.disconnect()
            }
        }
    }, [animationStart])

    return (
        <div className={cn(classes.Wrapper, {[classes.LangHY]: lang === 'hy'})}>
            {titleForm ? (
                <h2 className={`${classes.Title} ${classAnimationTitle}`} dangerouslySetInnerHTML={{ __html: titlePrint }} />
            ) : null}

            <div className={classes.Form}>
                {!successSubmit ? (
                    <>
                        <div className={classes.TextFieldWrap}>
                            <TextField
                                name='name'
                                label={data.name[lang]}
                                value={formData.name}
                                onChange={(e) => onChangeFormData('name', e.currentTarget.value)}
                                errorText={lang === 'en' ? 'Enter your name' : 'Մուտքագրեք ձեր անունը'}
                                isError={formErrors.name && !formData.name}
                            />

                            <div
                                className={`${classes.LineField} ${classAnimationLine}`}
                                data-active={isFormSend ? "Y" : null}
                            />
                        </div>

                        <div className={classes.TextFieldWrap}>
                            <TextField
                                name='email'
                                label={data.email[lang]}
                                value={formData.email}
                                onChange={(e) => onChangeFormData('email', e.currentTarget.value)}
                                errorText={lang === 'en' ? 'Enter your e-mail' : 'Մուտքագրեք ձեր էլ'}
                                isError={formErrors.email && !formData.email}
                                type='email'
                            />

                            <div
                                className={`${classes.LineField} ${classAnimationLine}`}
                                data-active={isFormSend ? "Y" : null}
                            />
                        </div>

                        <div className={classes.TextAreaWrap}>
                            <TextArea
                                name='message'
                                label={data.message[lang]}
                                value={formData.message}
                                onChange={(e) => onChangeFormData('message', e.currentTarget.value)}
                            />

                            <div
                                className={`${classes.LineField} ${classAnimationLine}`}
                                data-active={isFormSend ? "Y" : null}
                            />
                        </div>

                        <div className={classes.FormControl}>
                            <Button onClick={handleSubmit}>{data.send[lang]}</Button>

                            {lang === 'en' ? (
                                <p className={classes.Policy}>
                                    {`By pressing “Send” button I agree with`}
                                    <Link to={`/en/policy/`}>Privacy Policy</Link>
                                </p>
                            ) : (
                                <p className={classes.Policy}>
                                    {`Սեղմելով "Ուղարկել" կոճակը, Ես համաձայն եմ`}
                                    <Link to={`/policy/`}>գաղտնիության քաղաքականության</Link>
                                    {` հետ`}
                                </p>
                            )}
                        </div>
                    </>
                ) : (
                    <div className={`${classes.ThankWrap}`}>
                        <Thanks
                            open={successSubmit}
                            thanksTitle={
                                dataServer && dataServer.thanksTitle && dataServer.thanksTitle.value ? dataServer.thanksTitle.value : ''
                            }
                            thanksText={
                                dataServer && dataServer.thanksText && dataServer.thanksText.value ? dataServer.thanksText.value : ''
                            }
                            lang={lang}
                        />
                    </div>
                )}
            </div>
        </div>
    )
}

export default Form
